import Sortable from 'sortablejs';
import jQuery from 'jquery';

let ctrlPressed = false;
const lists = {};

const onKey = (event) => {
  ctrlPressed = event.ctrlKey;
  for (const list of Object.values(lists)) {
    list.update();
  }
};

document.addEventListener('keydown', onKey);
document.addEventListener('keyup', onKey);

export default (id, group, sort, copyable, component) => {
  const element = document.getElementById(id);

  const list = {
    active: false, copyable: copyable, update: () => {
      if (!list.copyable || !list.active) return;

      const drag = document.querySelector('.sortable-drag');
      const $drag = jQuery(drag);
      const $hint = $drag.find('.sortable-hint');

      let title = 'Moving...';
      let content = 'Hold Ctrl to make a copy instead.';

      if (ctrlPressed) {
        title = 'Copying...';
        content = 'Release Ctrl to move instead.';
      }

      if ($hint.length === 0) {
        $drag.prepend(`<div class="sortable-hint absolute -top-[2rem] left-0 leading-[1.5rem] bg-stone-500 text-xs text-white px-2 rounded-sm"><span class="font-bold">${title}</span> <span>${content}</span></div>`);
      } else {
        $hint.html(`<span class="font-bold">${title}</span> <span>${content}</span>`);
      }
    }
  }
  lists[id] = list;

  const sortable = new Sortable(element, {
    animation: 200,
    delay: 50,
    group: {
      name: group, pull: 'clone',
    },
    filter: `#${id} .ra-moveable-list`,
    sort: sort,
    forceFallback: true,
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    handle: undefined,
    onStart: async (event) => {
      list.active = true;
      await component.invokeMethodAsync('Start', event.oldIndex);
      list.update();
    },
    onEnd: async (event) => {
      list.active = false;
      if (list.copyable && ctrlPressed && event.newIndex === event.oldIndex && event.from.id === event.to.id) {
        await component.invokeMethodAsync('Copy', event.from.id, event.oldIndex, event.to.id, event.newIndex);
      }
    },
    onUpdate: async (event) => {
      if (event.clone) {
        event.clone.remove();
      }

      if (list.copyable && ctrlPressed) {
        await component.invokeMethodAsync('Copy', event.from.id, event.oldIndex, event.to.id, event.newIndex);

        event.item.remove();
        const childNodes = Array.from(event.from.childNodes).filter(node => node.nodeType === 1);
        if (childNodes.length > event.oldIndex) {
          event.from.insertBefore(event.item, childNodes[event.oldIndex]);
        } else {
          event.from.appendChild(event.item);
        }
      } else {
        await component.invokeMethodAsync('Move', event.from.id, event.oldIndex, event.to.id, event.newIndex);
      }
    },
    onRemove: async (event) => {
      if (event.clone) {
        event.clone.remove();
      }

      if (list.copyable && ctrlPressed) {
        await component.invokeMethodAsync('Copy', event.from.id, event.oldIndex, event.to.id, event.newIndex);

        event.item.remove();
        const childNodes = Array.from(event.from.childNodes).filter(node => node.nodeType === 1);
        if (childNodes.length > event.oldIndex) {
          event.from.insertBefore(event.item, childNodes[event.oldIndex]);
        } else {
          event.from.appendChild(event.item);
        }
      } else {
        await component.invokeMethodAsync('Move', event.from.id, event.oldIndex, event.to.id, event.newIndex);
      }
    },
    onClone: (event) => {
      event.clone.classList.add('sortable-ghost');
    },
  });

  return {
    dispose() {
      sortable.destroy();
      delete lists[id];
    }
  }
}
